import { MessageCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function WhatsAppFab({ content }) {
  const { lang, t } = useLang();
  if (!content?.whatsapp_number) return null;

  const message =
    lang === "en" ? content.whatsapp_message_en : content.whatsapp_message_it;
  const url = `https://wa.me/${content.whatsapp_number}?text=${encodeURIComponent(
    message || ""
  )}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("common.whatsapp_chat")}
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 group"
    >
      <span className="hidden sm:inline-flex items-center gap-2 bg-white/95 backdrop-blur shadow-lg rounded-full px-4 py-2 text-xs font-medium text-afb-ink border border-[color:var(--afb-cream)]">
        <span className="w-2 h-2 rounded-full bg-[#25D366] animate-pulse" />
        24/7
      </span>
      <span className="relative">
        <span className="afb-pulse w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1fb557] flex items-center justify-center text-white shadow-xl transition-transform group-hover:scale-105">
          <MessageCircle className="w-7 h-7" strokeWidth={1.6} />
        </span>
      </span>
    </a>
  );
}
